import Glide from '@glidejs/glide'

export default function imageSlider() {
	// VIDEO SLIDER
	const contentSlider = document.querySelector('.glideContentImage')
	const videoSlider = document.querySelector('.glideImageCarousel')

	let content = new Glide(contentSlider)
	let video = new Glide(videoSlider, {
		gap: 0,
		keyboard: false,
	})

	content.on('run', function () {
		video.go(`=${content.index}`)
	})

	content.mount()
	video.mount()
}
